<template>
  <draggable
    :options="{
      animation:300,
      handle: '.page-dragged',
    }"
    :list="menus"
    :move="moveElement"
    group="pagesList"
    tag="ul"
    @end="handleEndDrag"
  >
    <li
      v-for="(menu, index) in menus"
      :key="menu.id"
      :parent="menu.id"
      :parent-loc="index"
      :data-parent="menu.parent_id"
    >
      <div
        :id="`${menu.id}-${menu.name.toLowerCase().replaceAll(' ', '-')}`"
        :class="[
          {
            'page-child': menu.parent_id !== 0,
            'active': pageSelected && pageSelected.id === menu.id,
          },
          isParent
            ? (index === 0 && menus.length > 1
              ? (menus[1].type === 'menu' && menu.type === 'visible'
                ? ''
                : 'page-dragged'
              )
              : 'page-dragged')
            : 'page-dragged'
        ]"
        class="page"
        @click.stop="selectPage(menu)"
      >
        <div class="d-flex align-items-start">
          <img
            :src="pageSelected && pageSelected.id === menu.id ? menu.icon_active : menu.icon_white"
            class="page-icon"
          >
          <div class="page-name">{{ menu.name }}</div>
        </div>

        <i
          v-if="menu.child && menu.type === 'menu'"
          class="fa fa-chevron-down dropdown-icon"
        />

        <div
          :id="`editPage-${menu.id}`"
          class="page-config"
          @click.stop="openEditPage(menu)"
        >
          <img :src="require('@/assets/app-manager/icon/edit-page.svg')">
        </div>

        <!-- Popover edit menu -->
        <b-popover
          :ref="`editPage-${menu.id}`"
          :target="`editPage-${menu.id}`"
          triggers="manual"
          placement="bottom"
          container="sidebar-web"
        >
          <h3>Edit Menu</h3>
          <j-form-page
            :ref="`formEditPage-${menu.id}`"
            :is-popover="true"
            :mode="'edit'"
            :data-page="dataPageForEdit"
            :icon-options="iconOptions"
          />
          <div class="d-flex justify-content-end mt-3">
            <div class="page-trash">
              <i
                class="fa fa-trash fa-lg"
                @click="$emit('delete-page', { id: menu.id, name: menu.name })"
              />
            </div>
            <button
              class="button-border mr-2"
              @click="closeEditPage">
              Close
            </button>
            <button
              class="button-blue"
              @click="editPage"
            >
              Apply
            </button>
          </div>
        </b-popover>
      </div>

      <!-- Child menu -->
      <sidebar-menu
        v-if="menu.child && menu.type === 'menu'"
        ref="sidebarChildMenu"
        :menus="menu.child"
        :is-parent="false"
        :page-selected="pageSelected"
        :icon-options="iconOptions"
        :list-pages="listPages"
        @selected-page="changeSelectedPage"
        @close-create-page="$emit('close-create-page')"
        @save-page="$emit('save-page')"
        @update-page="updatePage"
        @delete-page="$emit('delete-page')"
        @reload-pages="$emit('reload-pages')"
      />

      <!-- Button add sub menu -->
      <div
        v-if="menu.child && menu.type === 'menu'"
        :id="`createSubPage-${menu.id}`"
        class="add-page add-sub-page"
        @click="openCreateSubPage(menu.id)"
      >
        <span>+</span>
        Add Sub Menu
      </div>

      <!-- Popover create sub menu -->
      <b-popover
        :ref="`createSubPage-${menu.id}`"
        :target="`createSubPage-${menu.id}`"
        triggers="manual"
        placement="bottom"
        container="sidebar-web"
      >
        <h3>Add Sub Menu</h3>
        <j-form-page
          :ref="`formSubPage-${menu.id}`"
          :is-popover="true"
          :mode="'createSub'"
          :icon-options="iconOptions"
        />
        <div class="d-flex justify-content-end mt-3">
          <button
            class="button-border mr-2"
            @click="closeCreateSubPage">
            Close
          </button>
          <button
            class="button-blue"
            @click="createSubPage"
          >
            Save
          </button>
        </div>
      </b-popover>
    </li>
  </draggable>
</template>

<script>
/* eslint-disable no-lonely-if, no-param-reassign, max-len */
import { mapState, mapActions } from 'vuex';
import draggable from 'vuedraggable';
// Components
import jFormPage from '@/views/setting/jFormPage';

export default {
  name: 'SidebarMenu',

  components: {
    draggable,
    jFormPage,
  },

  props: {
    menus: {
      required: true,
      type: Array,
    },
    isParent: {
      type: Boolean,
      default: true,
    },
    pageSelected: {
      type: Object,
      default: () => null,
    },
    iconOptions: {
      type: Array,
      default: () => [],
    },
    listPages: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      targetMoved: null,
      idCreateSubPage: null,
      idEditPage: null,
      dataPageForEdit: null,
      tess: '',
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['application_detail']),
  },

  methods: {
    ...mapActions('jStoreSetting', ['actionUpdatePage']),

    moveElement(evt) {
      // Drag to new page menu type
      if (evt.to.childNodes.length === 0) {
        this.targetMoved = Number(evt.to.closest('li').getAttribute('parent'));
      } else {
        const element = evt.to.querySelector('li');
        if (element) {
          this.targetMoved = Number(element.getAttribute('data-parent'));
        }
      }
      evt.draggedContext.element.parent_id = this.targetMoved;
    },

    handleEndDrag(evt) {
      // Disable drag page menu type to sub menu
      // is child menu
      if (evt.to.closest('li')) {
        const oldIndex = evt.oldIndex;
        const parentIndex = Number(evt.to.closest('li').getAttribute('parent-loc'));
        const index = evt.newIndex;
        const dataDragged = this.listPages[parentIndex].child[index];
        const typeDataDragged = dataDragged.type;

        if (typeDataDragged === 'menu') {
          this.listPages[parentIndex].child.splice(index, 1);
          dataDragged.parent_id = 0;
          this.listPages.splice(oldIndex, 0, dataDragged);
        } else {
          const isHaveNextData = !!this.listPages[parentIndex].child[index + 1];
          const newOrder = isHaveNextData ? this.listPages[parentIndex].child[index + 1].order : 0;
          this.listPages[parentIndex].child[index].order = newOrder;
          const parameter = this.listPages[parentIndex].child[index];
          this.actionUpdatePage({ parameter, useLoading: false }).then((res) => {
            if (!res.error) this.$emit('reload-pages');
          });
        }
      // is parent menu
      } else if (evt.to.closest('ul')) {
        const index = evt.newIndex;
        const isFirstIndex = !this.listPages[index - 1];
        const isHaveNextData = !!this.listPages[index + 1];
        const dataDragged = this.listPages[index];

        // If type of first index is visible and type of second page is menu, disable drag first index
        // If page dragged to first index & type is visible, change data order page to -1
        // If page dragged to first index & type is menu, change position page to previous position
        // If page dragged to between first index & last index, change data order page to next data order
        // If page type visible dragged to last index, change data order page to 0
        if (isFirstIndex && this.listPages[index].type === 'visible') {
          this.listPages[index].order = -1;
          const parameter = this.listPages[index];
          this.actionUpdatePage({ parameter, useLoading: false }).then((res) => {
            if (!res.error) this.$emit('reload-pages');
          });
        } else if (isFirstIndex && this.listPages[index].type === 'menu') {
          this.listPages.splice(index, 1);
          this.listPages.splice(evt.oldIndex, 0, dataDragged);
        } else if (!isFirstIndex) {
          const newOrder = isHaveNextData ? this.listPages[index + 1].order : 0;
          this.listPages[index].order = newOrder;
          const parameter = this.listPages[index];
          this.actionUpdatePage({ parameter, useLoading: false }).then((res) => {
            if (!res.error) this.$emit('reload-pages');
          });
        }
      }
    },

    isShowPopover(id) {
      return !!(this.pageSelected && this.pageSelected.id === id);
    },

    changeSelectedPage(page) {
      this.$emit('selected-page', page);
    },

    openCreateSubPage(id) {
      this.$emit('close-create-page');
      this.closeCreateSubPage();
      this.idCreateSubPage = id;
      this.$refs[`createSubPage-${id}`][0].$emit('open');
    },

    closeCreateSubPage() {
      if (this.$refs[`createSubPage-${this.idCreateSubPage}`]) {
        this.$refs[`createSubPage-${this.idCreateSubPage}`][0].$emit('close');
      }
      this.idCreateSubPage = null;
    },

    createSubPage() {
      this.$refs[`formSubPage-${this.idCreateSubPage}`][0].getData().then(async (data) => {
        const parameter = {
          application_id: this.application_detail.id,
          name: data.titlePage,
          type: data.selectedType,
          icon_id: data.selectedIcon.id,
          show_option: data.displayMode,
          type_platform: 1,
          order: 0,
          parent_id: this.idCreateSubPage,
        };
        this.$emit('save-page', parameter);
      });
    },

    selectPage(menu) {
      setTimeout(() => {
        if (!this.idEditPage) this.$emit('selected-page', menu);
      }, 100);
    },

    openEditPage(menu) {
      const iconSelected = this.iconOptions.find(f => f.id === menu.icon_id);
      this.closeEditPage();
      setTimeout(() => {
        this.dataPageForEdit = {
          icon: iconSelected || null,
          title: menu.name,
          type: menu.type,
          show_option: menu.show_option,
          id: menu.id,
          order: menu.order,
          parent_id: menu.parent_id,
        };
        this.idEditPage = menu.id;
        this.$refs[`editPage-${menu.id}`][0].$emit('open');
      }, 300);
    },

    closeEditPage() {
      if (this.$refs[`editPage-${this.idEditPage}`]) {
        this.$refs[`editPage-${this.idEditPage}`][0].$emit('close');
      }
      this.idEditPage = null;
      this.dataPageForEdit = null;
    },

    editPage() {
      this.$refs[`formEditPage-${this.idEditPage}`][0].getData().then(async (data) => {
        this.$emit('update-page', data);
        this.closeEditPage();
      });
    },

    updatePage(data) {
      this.$emit('update-page', data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/partials/sidebarMenu.vue